import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { IDischargeReportValidationIssue } from 'src/app/interfaces/DischargeReport/IDischargeReportValidation';

@Component({
  selector: 'app-discharge-report-validation-summary',
  standalone: true,
  imports: [CommonModule, TranslateModule, NzIconModule],
  templateUrl: './discharge-report-validation-summary.component.html',
  styleUrls: ['./discharge-report-validation-summary.component.css'],
})
export class DischargeReportValidationSummaryComponent {
  @Input() issues: IDischargeReportValidationIssue[] = [];
  @Input() warnings: IDischargeReportValidationIssue[] = [];
}